export default "__VITE_ASSET__nde9ZW$t__"